import projectsList from './projectsData/0_projectsList.json'
import projectConverImages from '../images/project-covers/project-covers.json'

const projects = [];
projectsList.forEach(async (id) => {
  try {
    const project = require(`../db/projectsData/${id}.json`);
    console.log(`Loading project file: ${id}.json`);
    console.log(project, "project");
    const coverImage = projectConverImages.find((img) => img.src.includes(id));
    console.log("projectConverImages", projectConverImages);
    console.log(coverImage, "coverImage");
    const coverImagePath = (await import(`../images/project-covers/${coverImage.src}`)).default
    if (coverImagePath) {
      project.coverImage = coverImagePath;
    }
    projects.push(project);
    console.log("projects------", projects);
  } catch (error) {
    console.error(`Error loading project file for ID: ${id}`, error);
  }
});

const getSortedProjects = () => {

  // Sort projects by the `weight` property
  projects.sort((a, b) => a.weight - b.weight);
  
  return projects;
};

const getProjectByPath = (path) => {
  const project = projects.find((project) => project.path === path);
  return project || null;
};

export { getProjectByPath, getSortedProjects };